import { P } from "@angular/cdk/keycodes";
import { APP_CONSTANTS } from "@app/_configs/constant";

export const resolvePublicUrl = (filePath: string): string => {
  if (!filePath) {
    return '';
  }
  const value = String(filePath).trim().replace(/\\/g, '/');
  if (!value) {
    return '';
  }
  if (/^(https?:|data:|blob:)/i.test(value) || value.indexOf('assets/') === 0) {
    return value;
  }
  const download = (APP_CONSTANTS.DOWNLOAD_URL || '').replace(/\/$/, '');
  const origin = (APP_CONSTANTS.SERVER_URL || '').replace(/\/$/, '');
  if (value.indexOf('/public/') === 0) {
    return origin + value;
  }
  if (value.indexOf('public/') === 0) {
    return origin + '/' + value;
  }
  if (value.charAt(0) === '/') {
    return download + value;
  }
  return download + '/' + value;
};

export const genRandomOrderString = (length) => {
  let result           = '';
  const characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for ( let i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const formatNumber = (str?:number, decimal:number = 2)=>{
  if(typeof str == 'undefined') str = 0;
  return str.toFixed(decimal);
};

export const toUppercase = (str) => {
  return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
};

export const getSlug = (str:string):string => {
  return str.toLowerCase().replace(/ /g, '-')
            .replace(/[^\w-]+/g, '');
}

export const scrollToTop = () => {
  if(document.querySelector('.mat-sidenav-content')){
    document.querySelector('.mat-sidenav-content').scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });   		
  }
}

const splitDate = (str) => {
  let date = new Date(str),
      year = date.getFullYear(),
      month = date.getMonth() + 1, m = ('0' + month.toString()).substr(-2),
      dt = date.getDate(), d = ('0' + dt.toString()).substr(-2),
      hour = date.getHours(), h = ('0' + hour.toString()).substr(-2),
      minute = date.getMinutes(), mit = ('0' + minute.toString()).substr(-2),
      second = date.getSeconds(), sec = ('0' + second.toString()).substr(-2);
  return {date: [year, m, d], time: [h, mit, sec]};
}

export const handleDate = (str) => {
  let datetime = splitDate(str);
  return datetime.date.join('-');
};

export const handleDateTime = (str) => {
  let datetime = splitDate(str);
  return datetime.date.join('-') + ' ' + datetime.time.join(':');
};

export const handleTime = (str) => {
  let datetime = splitDate(str);
  return datetime.time.join(':');
};

export const abs = (num) => {
  return Math.abs(num);
};

export const round = (num: string) => {
  return num ? parseFloat(num).toFixed(2) : '0.00';
};

export const diffHours = (date1, date2) => {
  let d1 = new Date(date1);
  let d2 = new Date(date2); 
  
  // To calculate the time difference of two dates
  let Difference_In_Seconds = (d2.getTime() - d1.getTime()) / 1000;
  let Difference_In_Minutes = Math.floor(Difference_In_Seconds / 60); 
  let sec = Math.floor(Difference_In_Seconds - Difference_In_Minutes * 60);
  let hour = Math.floor(Difference_In_Minutes / 60);
  let min = Difference_In_Minutes - hour * 60;  
  return hour + 'h ' + min + 'm ' + sec + 's';
}

export const getAge = (birthday) => {
  let d1 = new Date(birthday);
  let d2 = new Date();
  if(d1) {
    return d2.getFullYear() - d1.getFullYear();
  }
  return 0;
}

export const getPriceWithCurrency = (price:any)=> {
  price = Number(price);
  if(price>=0) {
    return '$' + price.toFixed(2);
  } else {
    return '-$' + Math.abs(price).toFixed(2);
  }
}

export const getRouterLink = (link:string='home', param?:string) => {
  let url = '/', result = [url];  
  if(APP_CONSTANTS.IS_FRONT) {
    url += link;
    result = [url];  
  } else {
    let online_store = 'restaurant', 
      private_web_address = getPrivateWebAddress();
    if(private_web_address == '') {
      if(link == 'home') {
        url += 'home';
      } else {
        url += 'error';
      }
    } else {
      url = '/' + online_store + '/' + private_web_address + '/' + link;
      result = [url];
    }
  }
  if(param) result.push(param);
  return result;
}

export const getPrivateWebAddress = () => {
  let private_web_address = '';
  if(!APP_CONSTANTS.IS_FRONT) {
    let online_store = 'restaurant';
    let url = window.location.href, tmp = url.split('/');
    for(let i=0;i<tmp.length;i++) {
      if(tmp[i] == online_store && i+1<tmp.length) {
        private_web_address = tmp[i+1];
      }
    }  
  }
  return private_web_address;
}

export const getDomain = () => {
  let href = window.location.href, 
      url = new URL(href);
  return url.hostname;
}

export const stripHtml = (html) => {
  let tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

export const ADDRESS = {
  street: [''],
  city: [''],
  suburb: [''],
  postcode: [''],
  state: [''],
  country: ['']
};

export const rolePermissionGroups = [
  {
    "uid": "product_costs",
    "label": "Product Costs"
  },
  {
    "uid": "labels",
    "label": "Labels"
  },
  {
    "uid": "discounts",
    "label": "Discounts"
  },
  {
    "uid": "sell",
    "label": "Sell"
  },
  {
    "uid": "customers",
    "label": "Customers"
  },
  {
    "uid": "products",
    "label": "Products"
  },
  {
    "uid": "reporting",
    "label": "Reporting"
  },
  {
    "uid": "ecommerce",
    "label": "Ecommerce"
  },
  {
    "uid": "setup",
    "label": "Setup"
  }
];
export const timezoneList = [
  'Europe/Andorra',
  'Asia/Dubai',
  'Asia/Kabul',
  'Europe/Tirane',
  'Asia/Yerevan',
  'Antarctica/Casey',
  'Antarctica/Davis',
  'Antarctica/DumontDUrville', 
  'Antarctica/Mawson',
  'Antarctica/Palmer',
  'Antarctica/Rothera',
  'Antarctica/Syowa',
  'Antarctica/Troll',
  'Antarctica/Vostok',
  'America/Argentina/Buenos_Aires',
  'America/Argentina/Cordoba',
  'America/Argentina/Salta',
  'America/Argentina/Jujuy',
  'America/Argentina/Tucuman',
  'America/Argentina/Catamarca',
  'America/Argentina/La_Rioja',
  'America/Argentina/San_Juan',
  'America/Argentina/Mendoza',
  'America/Argentina/San_Luis',
  'America/Argentina/Rio_Gallegos',
  'America/Argentina/Ushuaia',
  'Pacific/Pago_Pago',
  'Europe/Vienna',
  'Australia/Lord_Howe',
  'Antarctica/Macquarie',
  'Australia/Hobart',
  'Australia/Currie',
  'Australia/Melbourne',
  'Australia/Sydney',
  'Australia/Broken_Hill',
  'Australia/Brisbane',
  'Australia/Lindeman',
  'Australia/Adelaide',
  'Australia/Darwin',
  'Australia/Perth',
  'Australia/Eucla',
  'Asia/Baku',
  'America/Barbados',
  'Asia/Dhaka',
  'Europe/Brussels',
  'Europe/Sofia',
  'Atlantic/Bermuda',
  'Asia/Brunei',
  'America/La_Paz',
  'America/Noronha',
  'America/Belem',
  'America/Fortaleza',
  'America/Recife',
  'America/Araguaina',
  'America/Maceio',
  'America/Bahia',
  'America/Sao_Paulo',
  'America/Campo_Grande',
  'America/Cuiaba',
  'America/Santarem',
  'America/Porto_Velho',
  'America/Boa_Vista',
  'America/Manaus',
  'America/Eirunepe',
  'America/Rio_Branco',
  'America/Nassau',
  'Asia/Thimphu',
  'Europe/Minsk',
  'America/Belize',
  'America/St_Johns',
  'America/Halifax',
  'America/Glace_Bay',
  'America/Moncton',
  'America/Goose_Bay',
  'America/Blanc-Sablon',
  'America/Toronto',
  'America/Nipigon',
  'America/Thunder_Bay',
  'America/Iqaluit',
  'America/Pangnirtung',
  'America/Atikokan',
  'America/Winnipeg',
  'America/Rainy_River',
  'America/Resolute',
  'America/Rankin_Inlet',
  'America/Regina',
  'America/Swift_Current',
  'America/Edmonton',
  'America/Cambridge_Bay',
  'America/Yellowknife',
  'America/Inuvik',
  'America/Creston',
  'America/Dawson_Creek',
  'America/Fort_Nelson',
  'America/Vancouver',
  'America/Whitehorse',
  'America/Dawson',
  'Indian/Cocos',
  'Europe/Zurich',
  'Africa/Abidjan',
  'Pacific/Rarotonga',
  'America/Santiago',
  'America/Punta_Arenas',
  'Pacific/Easter',
  'Asia/Shanghai',
  'Asia/Urumqi',
  'America/Bogota',
  'America/Costa_Rica',
  'America/Havana',
  'Atlantic/Cape_Verde',
  'America/Curacao',
  'Indian/Christmas',
  'Asia/Nicosia',
  'Asia/Famagusta',
  'Europe/Prague',
  'Europe/Berlin',
  'Europe/Copenhagen',
  'America/Santo_Domingo',
  'Africa/Algiers',
  'America/Guayaquil',
  'Pacific/Galapagos',
  'Europe/Tallinn',
  'Africa/Cairo',
  'Africa/El_Aaiun',
  'Europe/Madrid',
  'Africa/Ceuta',
  'Atlantic/Canary',
  'Europe/Helsinki',
  'Pacific/Fiji',
  'Atlantic/Stanley',
  'Pacific/Chuuk',
  'Pacific/Pohnpei',
  'Pacific/Kosrae',
  'Atlantic/Faroe',
  'Europe/Paris',
  'Europe/London',
  'Asia/Tbilisi',
  'America/Cayenne',
  'Africa/Accra',
  'Europe/Gibraltar',
  'America/Godthab',
  'America/Danmarkshavn',
  'America/Scoresbysund',
  'America/Thule',
  'Europe/Athens',
  'Atlantic/South_Georgia',
  'America/Guatemala',
  'Pacific/Guam',
  'Africa/Bissau',
  'America/Guyana',
  'Asia/Hong_Kong',
  'America/Tegucigalpa',
  'America/Port-au-Prince',
  'Europe/Budapest',
  'Asia/Jakarta',
  'Asia/Pontianak',
  'Asia/Makassar',
  'Asia/Jayapura',
  'Europe/Dublin',
  'Asia/Jerusalem',
  'Asia/Kolkata',
  'Indian/Chagos',
  'Asia/Baghdad',
  'Asia/Tehran',
  'Atlantic/Reykjavik',
  'Europe/Rome',
  'America/Jamaica',
  'Asia/Amman',
  'Asia/Tokyo',
  'Africa/Nairobi',
  'Asia/Bishkek',
  'Pacific/Tarawa',
  'Pacific/Enderbury',
  'Pacific/Kiritimati',
  'Asia/Pyongyang',
  'Asia/Seoul',
  'Asia/Almaty',
  'Asia/Qyzylorda',
  'Asia/Qostanay', 
  'Asia/Aqtobe',
  'Asia/Aqtau',
  'Asia/Atyrau',
  'Asia/Oral',
  'Asia/Beirut',
  'Asia/Colombo',
  'Africa/Monrovia',
  'Europe/Vilnius',
  'Europe/Luxembourg',
  'Europe/Riga',
  'Africa/Tripoli',
  'Africa/Casablanca',
  'Europe/Monaco',
  'Europe/Chisinau',
  'Pacific/Majuro',
  'Pacific/Kwajalein',
  'Asia/Yangon',
  'Asia/Ulaanbaatar',
  'Asia/Hovd',
  'Asia/Choibalsan',
  'Asia/Macau',
  'America/Martinique',
  'Europe/Malta',
  'Indian/Mauritius',
  'Indian/Maldives',
  'America/Mexico_City',
  'America/Cancun',
  'America/Merida',
  'America/Monterrey',
  'America/Matamoros',
  'America/Mazatlan',
  'America/Chihuahua',
  'America/Ojinaga',
  'America/Hermosillo',
  'America/Tijuana',
  'America/Bahia_Banderas',
  'Asia/Kuala_Lumpur',
  'Asia/Kuching',
  'Africa/Maputo',
  'Africa/Windhoek',
  'Pacific/Noumea',
  'Pacific/Norfolk',
  'Africa/Lagos',
  'America/Managua',
  'Europe/Amsterdam',
  'Europe/Oslo',
  'Asia/Kathmandu',
  'Pacific/Nauru',
  'Pacific/Niue',
  'Pacific/Auckland',
  'Pacific/Chatham',
  'America/Panama',
  'America/Lima',
  'Pacific/Tahiti',
  'Pacific/Marquesas',
  'Pacific/Gambier',
  'Pacific/Port_Moresby',
  'Pacific/Bougainville',
  'Asia/Manila',
  'Asia/Karachi',
  'Europe/Warsaw',
  'America/Miquelon',
  'Pacific/Pitcairn',
  'America/Puerto_Rico',
  'Asia/Gaza',
  'Asia/Hebron',
  'Europe/Lisbon',
  'Atlantic/Madeira',
  'Atlantic/Azores',
  'Pacific/Palau',
  'America/Asuncion',
  'Asia/Qatar',
  'Indian/Reunion',
  'Europe/Bucharest',
  'Europe/Belgrade',
  'Europe/Kaliningrad',
  'Europe/Moscow',
  'Europe/Simferopol',
  'Europe/Kirov',
  'Europe/Astrakhan',
  'Europe/Volgograd',
  'Europe/Saratov',
  'Europe/Ulyanovsk',
  'Europe/Samara',
  'Asia/Yekaterinburg',
  'Asia/Omsk',
  'Asia/Novosibirsk',
  'Asia/Barnaul',
  'Asia/Tomsk',
  'Asia/Novokuznetsk',
  'Asia/Krasnoyarsk',
  'Asia/Irkutsk',
  'Asia/Chita',
  'Asia/Yakutsk',
  'Asia/Khandyga',
  'Asia/Vladivostok',
  'Asia/Ust-Nera',
  'Asia/Magadan',
  'Asia/Sakhalin',
  'Asia/Srednekolymsk',
  'Asia/Kamchatka',
  'Asia/Anadyr',
  'Asia/Riyadh',
  'Pacific/Guadalcanal',
  'Indian/Mahe',
  'Africa/Khartoum',
  'Europe/Stockholm',
  'Asia/Singapore',
  'America/Paramaribo',
  'Africa/Juba',
  'Africa/Sao_Tome',
  'America/El_Salvador',
  'Asia/Damascus',
  'America/Grand_Turk',
  'Africa/Ndjamena',
  'Indian/Kerguelen',
  'Asia/Bangkok',
  'Asia/Dushanbe',
  'Pacific/Fakaofo',
  'Asia/Dili',
  'Asia/Ashgabat',
  'Africa/Tunis',
  'Pacific/Tongatapu',
  'Europe/Istanbul',
  'America/Port_of_Spain',
  'Pacific/Funafuti',
  'Asia/Taipei',
  'Europe/Kiev',
  'Europe/Uzhgorod',
  'Europe/Zaporozhye',
  'Pacific/Wake',
  'America/New_York',
  'America/Detroit',
  'America/Kentucky/Louisville',
  'America/Kentucky/Monticello',
  'America/Indiana/Indianapolis',
  'America/Indiana/Vincennes',
  'America/Indiana/Winamac',
  'America/Indiana/Marengo',
  'America/Indiana/Petersburg',
  'America/Indiana/Vevay',
  'America/Chicago',
  'America/Indiana/Tell_City',
  'America/Indiana/Knox',
  'America/Menominee',
  'America/North_Dakota/Center',
  'America/North_Dakota/New_Salem',
  'America/North_Dakota/Beulah',
  'America/Denver',
  'America/Boise',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'America/Juneau',
  'America/Sitka',
  'America/Metlakatla',
  'America/Yakutat',
  'America/Nome',
  'America/Adak',
  'Pacific/Honolulu',
  'America/Montevideo',
  'Asia/Samarkand',
  'Asia/Tashkent',
  'America/Caracas',
  'Asia/Ho_Chi_Minh',
  'Pacific/Efate',
  'Pacific/Wallis',
  'Pacific/Apia',
  'Africa/Johannesburg'
];

/** Comma-separated names of the selected forced modifiers on a cart item, e.g. "Extra cheese ×2, No onion". */
export const getCartItemModifiersLabel = (item: any): string => {
  const names: string[] = [];
  const withQty = (modifier: any) => modifier.qty > 1 ? `${modifier.name} ×${modifier.qty}` : modifier.name;
  const groups: any[] = (item && (item.forced_modifier_groups || item.product?.data?.forced_modifier_group)) || [];
  groups.filter(group => group.isSelected).forEach(group => {
    (group.forced_modifiers || []).filter(modifier => modifier.isSelected).forEach(modifier => {
      names.push(withQty(modifier));
      (modifier.sub_group || []).filter(sub => sub.isSelected).forEach(sub => {
        (sub.forced_modifiers || []).filter(subItem => subItem.isSelected).forEach(subItem => names.push(withQty(subItem)));
      });
    });
  });
  return names.join(', ');
};
